import { AmountSuperScript } from "components/design/AmountSuperScript";
import ToolTip from "components/design/toolTip";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { FiQuestion } from "components/icons/FiQuestion";
import { formatDate } from "utils/formatDate";

type WithholdingSummary = {
  total_pending: number;
  due_date: string | null;
  is_overdue: boolean;
};

const HOW_THIS_WORKS_TOOLTIP_CONTENT = (
  <div>
    <p className="t-m-0 t-mb-1">
      Tax you&apos;ve withheld but not yet paid to the IRS.
    </p>
    <p className="t-m-0 t-mb-1">
      The due date depends on your total withheld for the year:
    </p>
    <ul className="t-m-0 t-mb-1 t-list-disc t-pl-4">
      <li>Under $200 → with your annual Form 1042 filing (Mar 15)</li>
      <li>$200–$2,000 → 15th of the next month</li>
      <li>
        $2,000+ → within 3 business days of the 7th / 15th / 22nd / month-end
      </li>
    </ul>
    <p className="t-m-0">Moves earlier as you withhold more.</p>
  </div>
);

export const WithholdingSummaryCard = ({
  summary,
}: {
  summary: WithholdingSummary;
}) => {
  return (
    <div className="t-flex t-flex-col t-gap-1">
      <div className="t-flex t-items-center t-gap-2">
        <div className="t-flex t-items-center t-gap-2 t-text-body-sm">
          <span className="t-inline-block t-h-2 t-w-2 t-shrink-0 t-rounded-full t-bg-orange-70" />
          <span className="t-text-text-30">
            {summary.due_date
              ? `Withholding owed to IRS by ${formatDate(summary.due_date)} `
              : "Withholding owed to IRS "}
          </span>
        </div>
        {summary.is_overdue && (
          <Tag tagType="red" rounded icon={false}>
            Overdue
          </Tag>
        )}
      </div>
      <div className="t-text-subtext t-text-text-100 t-ml-3.5">
        <AmountSuperScript amount={summary.total_pending} />
      </div>
      <span className="t-flex t-items-center t-gap-1 t-text-body-sm-lite t-text-text-30 t-w-max t-ml-3.5 t-cursor-default">
        How this works
        <ToolTip text={HOW_THIS_WORKS_TOOLTIP_CONTENT} propClass="!t-text-left">
          <span className="t-flex t-items-center">
            <FiQuestion />
          </span>
        </ToolTip>
      </span>
    </div>
  );
};
